<td *ngIf="collection.length <= 0" [colSpan]="columns"> No data available</td>
